import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  //Hook

  // declare usefull auth states

  const [token, setToken] = useState(null);
  const [role, setRole] = useState(null);
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  //Function
  const login = useCallback((token, role, user) => {
    setToken(token);
    setRole(role);
    setUser(user);
    localStorage.setItem("admin_anbessamart", JSON.stringify({ token, role, user }));
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setRole(null);
    setUser(null);
    localStorage.removeItem("admin_anbessamart");
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem("admin_anbessamart");
    if (storedData) {
      const adminData = JSON.parse(storedData);
      if (adminData?.token) {
        login(adminData.token, adminData.role, adminData.user);
        setChecked(true);
      }
    }
    setChecked(true);
  }, [login]);

  //Return
  return (
    <AuthContext.Provider value={{ token, role, user, checked, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
